// src/core/companySettings/useCompanySettings.js
import * as React from 'react';
import { companySettingsStore } from '../companySettingsStore';
import { tokenStorage } from 'shared/api/storage';

function isPublicPath(p) {
  return (
    p.startsWith('/rsvp/') ||
    p === '/sign-in' ||
    p === '/sign-up' ||
    p === '/forgot-password' ||
    p === '/verify-email' ||
    p === '/login' ||
    p === '/register'
  );
}

export function useCompanySettings() {
  const snap = React.useSyncExternalStore(
    companySettingsStore.subscribe,
    companySettingsStore.getSnapshot,
    companySettingsStore.getSnapshot
  );

  React.useEffect(() => {
    const p = window.location.pathname || '';

    // ✅ RSVP ve diğer public sayfalarda settings çekme
    if (isPublicPath(p)) return;

    // ✅ token yoksa settings çekme
    const tokens = tokenStorage.get();
    if (!tokens?.accessToken) return;

    // cache varsa hızlıca hydrate
    companySettingsStore.hydrateFromCacheIfEmpty();

    // settings yoksa API'den çek
    if (!companySettingsStore.getSnapshot().settings) {
      companySettingsStore.fetchFromApi().catch(() => {});
    }
  }, []);

  return {
    settings: snap.settings,
    loading: snap.loading,
    error: snap.error,
    refresh: companySettingsStore.refresh,
  };
}
